<template>
	<div class="page500">
		<Header ref="Header" :policy="false" />
		<div class="pageContent">
      <div class="icon_500"><img src="../assets/images/500.png"></div>
      <div class="toHome" @click="toHome">{{ langConfig['500'][langConfig.curLang]['BACK'] }}</div>
    </div>
    <Footer />
	</div>
</template>
<script>
import Header from "@/components/header.vue";
import NavBar from "@/components/navbar.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Header,
    NavBar,
    Footer,
  },
  data(){
    return{
      
    }
  },
  methods:{
    toHome(){
      this.$router.push('/')
    }
  }
};

</script>
<style lang="less">
.page500{
  .pageContent{
    height: calc(100vh - 375px);
    .icon_500{
      width: 200px;
      Height: 161px;
      font-size: 0;
      margin: 90px auto 40px auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .toHome{
      color: @color_FFF;
      font-family: @font_family_SF_Pro_Display;
      font-size: 18px;
      line-height: 40px;
      cursor: pointer;
      background: @color_FF6915;
      width: 300px;
      text-align: center;
      border-radius: 5px;
      margin: 0 auto 90px auto;
    }
  }
}
@media screen and (max-width: 767px) {
  .page500{
    .pageContent{
      height: calc(100vh - 3.52rem);
      .icon_500{
        width: 2rem;
        Height: 1.61rem;
        font-size: 0;
        margin: .9rem auto .4rem auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .toHome{
        font-size: .18rem;
        line-height: .4rem;
        width: 3rem;
        border-radius: .05rem;
        margin: 0 auto .9rem auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/views/500.vue